import React, { Suspense } from 'react';
import { MarketManagers } from 'components/context/market_managers';
import { OrderDetails } from 'components/context/order_details';
import { FeatureFlags } from 'components/context/feature_flags';
import { UserJourneysProvider } from 'components/context/user_journeys';
import PageLoader from 'components/common/page_loader';
import Checkout from 'components/pages/checkout/checkout';
import ShopTheme from 'theme/shop_theme';
import DashboardModeCompatiblePage from 'components/common/dashboard_mode_compatible_page';
import { BrowserRouter } from 'react-router-dom';
// eslint-disable-next-line import/no-unassigned-import
import 'utilities/i18n';
import { datadogRum } from '@datadog/browser-rum';

const CheckoutApp = (props) => {
  const basePath = '/shop/hardware/\\w{2}/\\w{2}/checkout/v2';

  // Set additional global context for Datadog RUM
  datadogRum.setGlobalContext(props.rumAttributes || {});

  return (
    <ShopTheme>
      <Suspense fallback={<PageLoader delayMs={500} />}>
        <MarketManagers>
          <FeatureFlags {...props}>
            <OrderDetails {...props}>
              <BrowserRouter
                basename={window.location.pathname.match(basePath)[0]}
              >
                <DashboardModeCompatiblePage>
                  <UserJourneysProvider {...props}>
                    <Checkout />
                  </UserJourneysProvider>
                </DashboardModeCompatiblePage>
              </BrowserRouter>
            </OrderDetails>
          </FeatureFlags>
        </MarketManagers>
      </Suspense>
    </ShopTheme>
  );
};

export default CheckoutApp;
